<app-loader *ngIf="isDisabled"></app-loader>
<div class="row">
    <div class="col"></div>
    <div class="col-auto">
        <button type="button" class="btn btn-primary btn-sm" (click)="addResignationReason(0,'','')">
            <i class="bi bi-plus-lg"></i>Add Resignation Reason</button>
    </div>
</div>

<div class="card mb-3 mt-2">
    <div class="card-header">Resignation Reason Master</div>
    <div class="card-body">
        <div class="row">
            <table datatable [dtOptions]="dtoptions" [dtTrigger]="dtTrigger" class="table table-bordered overflow-auto">
                <thead>
                    <tr>
                        <th style="width:5px">#</th>
                        <th>Reason Name</th>
                        <th style="width:5px">Active</th>
                        <th style="width:5px">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of TableData; let i = index">
                        
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" name="sample" (click)="exportToExcel()">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>